import styled, { css } from 'styled-components'

export const FormInputLabelStyled = styled.div`
  margin-bottom: 10px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.5px;
  color: ${({ theme }) => theme.greyishBrown};
`

export const FormInputStyled = styled.input`
  display: block;
  padding: 15px;
  border: 2px solid ${({ theme }) => theme.veryLightPink};
  font-size: 14px;
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  color: ${({ theme }) => theme.greyishBrown};
  border-radius: 6px;
  transition: border .15s;
  width: 100%;
  ::placeholder {
    color: ${({ theme }) => theme.lightPeach};
  }
  ${({ marginVertical }) =>
    marginVertical &&
    css`
        margin-top: 10px;
        margin-bottom: 10px;
    `
  }
`

export const FormInputError = styled.div`
  color: ${({ theme }) => theme.pastelRed};
  font-size: 12px;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-top: 5px;
  margin-bottom: 5px;
  height: 15px;
  opacity: 0;
  transition: opacity .15s;
`

export const FormInputLabelWrapperStyled = styled.label`
  display: block;
  position: relative;
  margin: ${({ margin }) => margin ? margin : 0};
  max-width: ${({ maxWidth }) => maxWidth ? maxWidth : 'auto'};
  ${({ error }) =>
    error &&
    css`
      ${FormInputStyled} {
        border: 2px solid ${({ theme }) => theme.pastelRed};
      }
      ${FormInputError} {
        opacity: 1;
      }
    `
  }
   ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `
  }
`